export interface ConflictData<T = unknown> {
  import?: T;
  student?: T | null;
  passport?: T;
  manual?: T;
  agent?: T | null;
  option?: string;
  resolvedValue?: T | null;
}

export interface AgentDisplayNameConflictData extends ConflictData<string> {
  importAlias?: string;
}

export interface ConflictIndexed<T = unknown> {
  index: number;
  data?: ConflictData<T>;
}

export interface IConflictHistoryCourses {
  courseName?: Array<ConflictIndexed<string>>;
  courseStartDate?: Array<ConflictIndexed<string>>;
  courseEndDate?: Array<ConflictIndexed<string>>;
  courseFee?: Array<ConflictIndexed<number>>;
  courseScholarshipAmount1?: Array<ConflictIndexed<number>>;
  courseIsWorkPlacement?: Array<ConflictIndexed<boolean>>;
  courseOfferEvidence?: Array<ConflictIndexed<string>>;
}

export interface IConflictHistoryMain {
  studentNo?: ConflictData<string>;
  gender?: ConflictData<string>;
  familyName?: ConflictData<string>;
  middleName?: ConflictData<string>;
  givenName?: ConflictData<string>;
  dob?: ConflictData<string>;
  nationality?: ConflictData<string>;
  birthCountry?: ConflictData<string>;
  passportNumber?: ConflictData<string>;
  passportExpiry?: ConflictData<string>;

  courseDiscount?: ConflictData<Array<string>>;
  courseFeeDeposit?: ConflictData<number>;
  // Similar to courseFeeDeposit
  // Is needed since depositAmount is the field that is imported and being used in Summary
  // and that field is listed in the importStudentFields and used to set conflict conditions
  // ENROLY-177
  depositAmount?: ConflictData<number>;
  accomFeeDeposit?: ConflictData<number>;

  agentDisplayName?: AgentDisplayNameConflictData;
  agentFamilyName?: ConflictData<string>;
  agentGivenName?: ConflictData<string>;
  branchAddressLine1?: ConflictData<string>;
  branchAddressLine2?: ConflictData<string>;
  branchAddressLine3?: ConflictData<string>;
  branchCity?: ConflictData<string>;
  branchCountry?: ConflictData<string>;
  branchPostcode?: ConflictData<string>;
}

export interface IConflictSummary {
  studentNo?: boolean;
  gender?: boolean;
  surname?: boolean;
  middleName?: boolean;
  givenName?: boolean;
  dob?: boolean;
  nationality?: boolean;
  birthCountry?: boolean;
  passportNumber?: boolean;
  passportExpiry?: boolean;
  courseDiscount?: boolean;
  courseFeeDeposit?: boolean;
  accomFeeDeposit?: boolean;
  courseName?: boolean;
  courseStartDate?: boolean;
  depositAmount?: boolean;
  courseEndDate?: boolean;
  courseFee?: boolean;
  courseScholarshipAmount1?: boolean;
  courseIsWorkPlacement?: boolean;
  courseOfferEvidence?: boolean;
  agentDisplayName?: boolean;
  agentFamilyName?: boolean;
  agentGivenName?: boolean;
  branchAddressLine1?: boolean;
  branchAddressLine2?: boolean;
  branchAddressLine3?: boolean;
  branchCity?: boolean;
  branchCountry?: boolean;
  branchPostcode?: boolean;
}

export const AGENT_DETAIL_CONFLICT_KEYS = [
  'agentDisplayName',
  'agentFamilyName',
  'agentGivenName',
  'branchAddressLine1',
  'branchAddressLine2',
  'branchAddressLine3',
  'branchCity',
  'branchCountry',
  'branchPostcode',
] as const;

export const AGENT_CONFLICT_SUMMARY_KEYS: Array<keyof IConflictSummary> = [...AGENT_DETAIL_CONFLICT_KEYS];

export type AgentDetailFieldName = Exclude<(typeof AGENT_DETAIL_CONFLICT_KEYS)[number], 'agentDisplayName'>;

export interface IConflictHistory extends IConflictHistoryMain, IConflictHistoryCourses {}

export interface IConflictHistoryDoc {
  p_key: string;
  s_key: string;
  docType: string;

  data: IConflictHistory;
}
